import type { SliceStateCreator } from "../types";

export interface UnreadChatRoomsSliceState {
  unread: {
    unreadChatRoomUuids: {
      [key: number]: string[];
    };
    setUnreadChatRoomUuids: (communityId: number, uuids: string[]) => void;
    appendUnreadChatRoomUuids: (communityId: number, uuid: string) => void;
  };
}

export const createUnreadChatRoomsSlice: SliceStateCreator<
  UnreadChatRoomsSliceState
> = set => ({
  unread: {
    unreadChatRoomUuids: {},
    setUnreadChatRoomUuids: (communityId, uuids) =>
      set(state => {
        state.unread.unreadChatRoomUuids[communityId] = uuids;
      }),
    appendUnreadChatRoomUuids: (communityId, uuid) =>
      set(state => {
        if (!state.unread.unreadChatRoomUuids[communityId]) {
          state.unread.unreadChatRoomUuids[communityId] = [];
        }
        state.unread.unreadChatRoomUuids[communityId].push(uuid);
      }),
  },
});
